import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { ClickAwayListener } from "@mui/base";
import { StyledPaper } from "./SettingsDropDown.styles";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store/hooks";
export function OrganizationsMenu({
  setOpenOrganizationMenu,
  openOrganizationMenu,
  openAdvancedSettings,
  setOpenAdvancedSettings,
}: OrganizationsMenuProps) {
  const navigate = useNavigate();
  const userType = useAppSelector((state) => state.user.user_type);

  function handleOrganizationsClick() {
    setOpenAdvancedSettings(!openAdvancedSettings);
    setOpenOrganizationMenu(!openOrganizationMenu);
  }

  function handleClose() {
    setOpenOrganizationMenu(!openOrganizationMenu);
  }

  function handleClickAway() {
    setOpenOrganizationMenu(false);
  }
  function handleCreateOrganization() {
    setOpenOrganizationMenu(false);
    setOpenAdvancedSettings(false);
    navigate("/organization/new");
  }
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <StyledPaper>
        <MenuList>
          <MenuItem onClick={handleOrganizationsClick}>
            <ListItemIcon>
              <KeyboardArrowLeftIcon htmlColor="#000000" />
            </ListItemIcon>
            <ListItemText>
              <strong>Organizations</strong>
            </ListItemText>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <ManageAccountsIcon htmlColor="#000000" />
            </ListItemIcon>
            <ListItemText>Manage organizations</ListItemText>
            <Typography variant="body2" color="text.secondary">
              <KeyboardArrowRightIcon htmlColor="#000000" />
            </Typography>
          </MenuItem>
          {(userType === "myself" || userType === "volunteer") && (
            <>
              <MenuItem onClick={handleCreateOrganization}>
                <ListItemIcon>
                  <PersonAddAltIcon htmlColor="#000000" />
                </ListItemIcon>
                <ListItemText>Create organization</ListItemText>
                <Typography variant="body2" color="text.secondary"></Typography>
              </MenuItem>
            </>
          )}
        </MenuList>
      </StyledPaper>
    </ClickAwayListener>
  );
}
